import { render } from "./TextItem.vue?vue&type=template&id=140463b7&scoped=true"
import script from "./TextItem.vue?vue&type=script&lang=js"
export * from "./TextItem.vue?vue&type=script&lang=js"

import "./TextItem.vue?vue&type=style&index=0&id=140463b7&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140463b7"]])

export default __exports__